const responseStack = [];
const onResponseCollectedCallbacks = [];

export function collectResponse(response) {
    responseStack.push(response);
    for (let callback of onResponseCollectedCallbacks) {
        callback(response);
    }
}

export function clearResponseStack() {
    responseStack.length = 0;
}

export function onCollectedResponse(callback, forceCurrentStack) {
    onResponseCollectedCallbacks.push(callback);

    if (forceCurrentStack) {
        for (const response of responseStack) {
            callback(response);
        }
    }
}
